import React, { useState, } from 'react';
import {
    Box, Typography, TextField, Button, Divider
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import PrintIcon from '@mui/icons-material/Print';
import Grid from '@mui/material/Grid2';
import { useSnackbar } from 'notistack';
import StudentServices from '../services/StudentServices';

import contact_img from '~/assets/images/contact_img.png';

function formatDate(dateInput, formatType = 'dd/mm/yyyy') {
    if (!dateInput) return "";

    const date = new Date(dateInput);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    if (formatType === 'yyyy-mm-dd') {
        return `${year}-${month}-${day}`;
    } else if (formatType === 'dd/mm/yyyy') {
        return `${day}/${month}/${year}`;
    } else {
        throw new Error("formatType must be 'dd/mm/yyyy' or 'yyyy-mm-dd'");
    }
}


const InforStudent = () => {
    const [student, setStudent] = useState({});
    const [searchString, setSearchString] = useState("");

    const { enqueueSnackbar } = useSnackbar();
    const showAlert = (message, variant) => {
        enqueueSnackbar(message, { variant });
    };
    const getStudent = async () => {
        try {
            const response = await StudentServices.getByStudentCodeOrIdentNumber(searchString);
            if (response) {
                setStudent(response);
                if (response.id) {
                    showAlert("Đã tìm thấy thông tin thí sinh!", "success");
                } else {
                    showAlert("Không tìm thấy thông tin thí sinh!", "warning");
                }
            }
        } catch (error) {
            showAlert("Lỗi khi lấy thông tin thí sinh!", "error");
            console.log(error);
        }
    };

    const handleChangeSearch = (event) => {
        if (searchString === "") {
            setStudent({});
        } else {
            getStudent();
        }
    };

    const exportExamRegistration = async () => {
        try {
            const response = await StudentServices.generateExamRegistrationZip([student]);
            if (response) {
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${student.name + "-" + student.identNumber}.docx`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                showAlert("In thông tin thí sinh thành công!", "success");
            }
        } catch (error) {
            showAlert("Lỗi khi in thông tin thí sinh!", "error");
            console.log(error);
        }
    };
    return (
        <Box sx={{ mt: 2, pb: 6 }}>
            <Box
                sx={{
                    minHeight: 250,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: 26,
                    fontWeight: 'bold',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${contact_img})`,
                    backgroundPosition: 'center'

                }}>
                THÔNG TIN THÍ SINH
            </Box>
            <Box
                sx={{
                    maxWidth: 'lg', marginInline: { xs: 2, md: 'auto' }, marginBlock: 8, paddingInline: { sm: 6, xs: 4 }, paddingBlock: 6,
                    backgroundColor: 'var(--white)', boxSizing: "border-box",
                    borderRadius: 4, minHeight: "50vh", boxShadow: "0 4px 20px 5px rgba(0, 0, 0, 0.2)"
                }}>
                <Box>
                    <Typography
                        sx={{ fontWeight: "bold", fontSize: { xs: 22, md: 26 }, color: "var(--primary)", textAlign: "center", mb: 4, mt: 2 }}>
                        TÌM KIẾM THÔNG TIN THÍ SINH
                    </Typography>
                    <Typography sx={{ textAlign: 'justify', mb: 2 }}>
                        Chức năng này cho phép bạn tìm đến thông tin của mình thông qua mã sinh viên hoặc căn cước công dân.
                        Bạn có thể cập nhật lại phiếu đăng ký trong thời gian cho phép. Hãy liên hệ với FLIC một khi phát hiện
                        sai sót trong phiếu đăng ký mà bạn không thể chỉnh sửa được.
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: 2, }}>
                        <TextField
                            label="Mã số SV / Số CCCD"
                            variant="outlined"
                            onChange={(e) => setSearchString(e.target.value)}
                            size="small"
                            sx={{ width: { sm: "50%", xs: "100%" } }}
                        />
                        <Button variant="contained" size="medium"
                            sx={{ textWrap: "nowrap", width: { sm: "fit-content", xs: "100%" } }}
                            onClick={handleChangeSearch}>
                            <SearchIcon />
                            <Typography>Tìm kiếm</Typography>
                        </Button>
                    </Box>
                </Box>
                {student && student.id && (
                    <Box sx={{ mt: 8 }}>
                        <Typography
                            sx={{ fontWeight: "bold", fontSize: { xs: 22, md: 26 }, color: "var(--primary)", textAlign: "center", mb: 6, mt: 2 }}>
                            THÔNG TIN THÍ SINH
                        </Typography>

                        <Grid container spacing={5}>
                            <Grid size={{ md: 3 }}>
                                <Box>
                                    <img src={process.env.REACT_APP_API_BASE_URL + student?.avatar} className="img-cover" style={{ minHeight: 250 }} alt="" />
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 3, gap: 1 }}>
                                    <Typography style={{ fontWeight: 'bold' }}>Trạng thái đăng ký: </Typography>

                                    <Typography style={{ fontWeight: "bold", color: student?.statusName === "Đã đăng ký" ? "blue" : student?.statusName === "Đã duyệt" ? "green" : "red" }}>
                                        {student?.statusName}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{ textAlign: { xs: "center" }, mt: 3 }}>
                                    <Button variant="contained" size="medium" endIcon={<PrintIcon />}
                                        onClick={exportExamRegistration}
                                        sx={{ width: "100%" }}
                                    >
                                        IN PHIẾU ĐĂNG KÝ
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid size={{ md: 9 }}>
                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Họ và tên: </span>{student?.name}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Mã sinh viên: </span>{student?.studentCode}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Ngày sinh: </span>{formatDate(student?.birthday)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Nơi sinh: </span>{student?.placeBirth}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Giới tinh: </span>{student?.sex}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Dân tộc: </span>{student?.nation}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Lớp: </span>{student?.classStudent}

                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Khoa: </span>{student?.departmentName}

                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Email: </span>{student?.email}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Số điện thoại: </span>{student?.phone}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}> Số CCCD: </span>{student?.identNumber}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Ngày cấp: </span>{formatDate(student?.dateIssue)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Nơi cấp: </span>{student?.placeIssue}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Lớp tin học: </span>{student?.itClass}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Đối tượng dự thi: </span>{student?.contestants}
                                        </Typography>
                                    </Grid>
                                    {/* <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Trạng thái đăng ký: </span>
                                            <span style={{ fontWeight: "bold", color: student?.statusName === "Đã đăng ký" ? "blue" : student?.statusName === "Đã duyệt" ? "green" : "red" }}>
                                                {student?.statusName}
                                            </span>
                                        </Typography>
                                    </Grid> */}
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Bậc thi: </span>
                                            {student?.level}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Đợt thi: </span>{student?.nameExam}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography variant="body1">
                                            <span style={{ fontWeight: 'bold' }}>Ngày thi: </span> {formatDate(student?.examDay)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }} >
                                        <Box>
                                            <Typography
                                                variant="h6"
                                                sx={{ fontWeight: "bold", color: "var(--primary)", marginBlock: 3 }}>
                                                THÔNG TIN BẢO LƯU
                                            </Typography>
                                            <Typography sx={{ mb: { xs: 2, md: 3 } }}>
                                                <span style={{ fontWeight: 'bold' }}>Thi lần 1: </span>{student?.prevExamDay && formatDate(student?.prevExamDay)}
                                            </Typography>
                                            <Typography sx={{ mb: { xs: 2, md: 3 } }}>
                                                <span style={{ fontWeight: 'bold' }}>Môn bảo lưu: </span>{student?.deferredSubject}
                                            </Typography>
                                            <Typography sx={{ mb: { xs: 2, md: 3 } }}>
                                                <span style={{ fontWeight: 'bold' }}>Thi lại môn: </span>{student?.resitSubject}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>


                        <Divider sx={{ marginBlock: 4 }} />
                        <Box sx={{ backgroundColor: "var(--primary)", color: "var(--white)", p: { sm: 4, xs: 2 }, borderRadius: 4 }}>
                            <Typography sx={{ fontWeight: 'bold', textTransform: "uppercase" }}>Lưu ý:</Typography>
                            <Typography sx={{ mt: 1, ml: 2 }}>
                                Khi đi thi, thí sinh mang theo một trong các loại giấy tờ tùy thân như: CMND, CCCD, Hộ chiếu (Passport)
                            </Typography>
                            <Typography sx={{ mt: 1, ml: 2 }}>
                                Thí sinh không mang theo tư trang cá nhân (kể cả ví, đồng hồ đeo tay và
                                điện thoại di động) và các thiết bị thu phát sóng khác vào phòng thi
                            </Typography>
                            <Typography sx={{ mt: 1, ml: 2 }}>
                                Thí sinh sử dụng nhất quán 01 chữ ký khi dự thi.
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>

    )
}

export default InforStudent;